/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `pending` - 대기 중
 * `in_progress` - 진행 중
 * `completed` - 완료
 * `failed` - 실패
 */
export type GenerationLogStatusEnum =
  (typeof GenerationLogStatusEnum)[keyof typeof GenerationLogStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerationLogStatusEnum = {
  pending: "pending",
  in_progress: "in_progress",
  completed: "completed",
  failed: "failed",
} as const;
